import React, { useState, useEffect, useContext, Fragment } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Modal from 'react-bootstrap/Modal';
import Modal from '@mui/material/Modal';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Header from './Header';
import Details from './Details';
import DetailsV3 from './Details/v3';
import Sidebar from './Sidebar';
import { ObjModal } from '../../contexts';
import { ToastContainer } from 'react-toastify';
import { update } from '../../common/api';
import { toast } from 'react-toastify';


const TFObject = ( { aid, uid, orgId, objType, obj, oid, objPick, header, details, sidebar } ) => {
    const [ draftValues, setDraftValues ] = useState( {} );
    const [ showSave, setShowSave ] = useState( false );
    const [ modal, setModal ] = useState();
    const [ show, setShow ] = useState( false );
    const [ extraFields, setExtraFields ] = useState( {} );
    const [ extraReady, setExtraReady ] = useState( false );

    const closeModal = () => setShow( false );
    const openModal = () => setShow( true );

    const handleSave = async () => {
        console.log( 'Saving: ' + objType + ' - ' + oid, draftValues );
        const updated = await update( orgId, obj.details.aid, uid, objType, oid, draftValues, ( obj.details.shared === true ) ? true : false );
        if ( updated.length ) {
            toast.success( `Your changes have been saved`, { theme: 'dark' } );
        } else {
            alert( 'Failed to save your update - please try again.  If the problem persists, please notify support@thirdfloor.ai' );
        }
    }

    const handleCancel = () => {
        // window.location.reload( false );
    }

    const getDraftValue = ( field ) => {
        return draftValues[field];
    }

    const getValue = ( dbField ) => draftValues[dbField] !== undefined ? draftValues[dbField] : obj.details[dbField];

    useEffect( () => {
        let hasOrig = false;
        let cleanDraft = {};
        let orig = [];

        Object.keys( draftValues ).forEach( d => {
            console.log( 'evaluating draft: ' + d + ' - ' + draftValues[d] );
            if ( draftValues[d] === obj.details[d] ) {
                hasOrig = true;
                console.log( d + ': matches orig - need to remove from drafts' );
                orig.push( d );
            } else if ( typeof draftValues[d] !== 'boolean' && ( !draftValues[d] || !draftValues[d].length ) && !obj.details[d] ) {
                hasOrig = true;
                console.log( d + ': not boolean && no data in draft && no orig data - need to remove from drafts' );
                orig.push( d )
            } else { 
                console.log( 'new value: ' + d + ' - ' + draftValues[d] );
                console.log( 'orig value: ' + obj.details[d] )
                cleanDraft[d] = draftValues[d];
            }
        } );

        if ( hasOrig ) {
            setDraftValues( ( prevState ) => {
                orig.forEach( o => delete prevState[o] );
                return { 
                    ...prevState,
                    ...cleanDraft 
                }
            } );
        }

        setShowSave( Object.keys( cleanDraft ).length );
    }, [ draftValues, obj.details ] );

    useEffect( () => {
        if ( Object.keys( extraFields ).length ) {
            setExtraReady( true );
        }
    }, [ extraFields ] );


    return (
        <Container fluid className='p-0'>
            <ObjModal.Provider value={ { objType, obj, oid, objPick, setDraftValues, openModal, closeModal, setModal, getDraftValue, getValue, extraFields, setExtraFields, extraReady, setExtraReady } }>
                <Row className='tf-page-container'>
                    <Col className='p-0'>
                        <Header layout={header} />
                    </Col>
                </Row>
                <Row>
                    <Col className='pe-0' md={ ( sidebar ) ? 8 : 12 }>
                        <Row className='tf-section-container mt-0 me-2 p-0'>
                            <Col className='p-0'>
                            {
                                ( details && details.version && details.version === 'v3' ) ? (
                                    <DetailsV3 layout={details} />
                                ) : (
                                    <Details layout={details} />
                                )
                            }
                            </Col>
                        </Row>
                    </Col>
                    {
                        ( sidebar ) ? (
                            <Col className='ps-0' md={4}>
                                <Sidebar layout={sidebar} />
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
                <Modal open={show} onClose={closeModal}>
                    <Fragment>
                        {modal}
                    </Fragment>
                </Modal>
            </ObjModal.Provider>
            <ToastContainer autoClose={3000} />
            {
                showSave ? (
                    <Fragment>
                        <Container style={ { height: '25px' } }></Container>
                        <Navbar fixed='bottom'>
                            <Container fluid className='m-0 p-0'>
                                <Row className='tf-save-footer-container w-100 align-items-center justify-content-md-center'>
                                    <Col xs='auto'><Button size='sm' variant='primary' onClick={handleSave}>Save</Button></Col>
                                    <Col xs='auto'><Button size='sm' variant='outline-light' onClick={handleCancel}>Cancel</Button></Col>
                                </Row>
                            </Container>
                        </Navbar>
                    </Fragment>
                ) : (
                    <Fragment />
                )
            }
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    orgId: state.user.orgId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( TFObject );